module.exports = __webpack_public_path__ + "static/media/tenants.3033487b.svg";